import {Box, Grid, Stack, Typography} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import Page from "../Components/Page";
import Preloader from "../Components/Preloader";
import ArticleCard from "../Components/ArticleCard";
import {useArticles} from "../Util/useArticles";
import {SectionType, subjectColours, subjectsForType} from "../Util/constants";
import {capitalise} from "../Util/util";

// Shared landing page for both /learn and /news. The section type is read from
// the route, and drives which articles are fetched — the layout is identical.
export default function SectionPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const type = (location.pathname.split("/")[1] || "news") as SectionType;

    const articles = useArticles(type);

    if (!articles) return <Page><Preloader visible size="60px"/></Page>;

    const [featured, ...rest] = articles;
    const subjects = subjectsForType(type);

    return (
        <Page metaTitle={`${capitalise(type)} | Scimos`} title={capitalise(type)} titleUnderline grid>
            {featured && <ArticleCard grid xs={12} article={featured} variant={"featured"}/>}

            {subjects.map((subject) => {
                const subjectArticles = rest.filter((a) => a.subject === subject).slice(0, 3);
                if (subjectArticles.length === 0) return null;
                return (
                    <Grid item xs={12} sm={6} md={4} key={subject}>
                        <Stack spacing={1.5}>
                            <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "baseline", borderBottom: `2px solid ${subjectColours[subject]}`, pb: 0.5}}>
                                <Typography variant={"h6"} sx={{color: subjectColours[subject]}}>{`Recent ${capitalise(subject)}`}</Typography>
                                <Typography variant={"caption"} sx={{cursor: "pointer"}} onClick={() => navigate(`/${type}/${subject}`)}>See more…</Typography>
                            </Box>
                            {subjectArticles.map((article) => <ArticleCard key={article.id} article={article} variant={"row"}/>)}
                        </Stack>
                    </Grid>
                );
            })}
        </Page>
    );
}
